import { PropsWithChildren, FunctionComponent } from 'react'
import PartDFMReportFeedbackCard from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/PartDFMReportFeedbackCard'
import {
    salesOrderLines_salesOrderLines_items_quoteModelRevision_dfmReports as DfmReportsType,
    salesOrderLines_salesOrderLines_items_quoteModelRevision_quoteModel_quote as QuoteType,
} from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrderLines'

type DfmReportsWrapperType = {
    dfmReports: DfmReportsType[]
    qmrId?: string
    quote?: QuoteType
    refetchQuery: any
}

export const DfmReportsWrapper: FunctionComponent<
    PropsWithChildren<DfmReportsWrapperType>
> = props => {
    const { dfmReports, qmrId, quote, refetchQuery } = props

    return (
        <PartDFMReportFeedbackCard
            quoteId={quote?.id}
            qmrId={qmrId}
            quoteUserId={quote?.user?.id}
            refetchQuery={refetchQuery}
            dfmReports={dfmReports}
            isPartViewerModal
        />
    )
}
